export enum ManageColors {
	PRIMARY = 'var(--color-manage-primary)',
	PRIMARY900 = 'var(--color-manage-primary-900)',
	PRIMARY800 = 'var(--color-manage-primary-800)',
	PRIMARY700 = 'var(--color-manage-primary-700)',
	PRIMARY600 = 'var(--color-manage-primary-600)',
	PRIMARY500 = 'var(--color-manage-primary-500)',
	PRIMARY400 = 'var(--color-manage-primary-400)',
	PRIMARY300 = 'var(--color-manage-primary-300)',
	PRIMARY200 = 'var(--color-manage-primary-200)',
	PRIMARY100 = 'var(--color-manage-primary-100)',
}
